import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const ProtectedRoute = ({ children, allowedRoles }) => {
    const { user, isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    // If allowedRoles is specified, check if user has the required role
    if (allowedRoles && allowedRoles.length > 0) {
        if (!user?.role || !allowedRoles.includes(user.role)) {
            // Redirect non-allowed users to their appropriate dashboard
            const redirectPath = user?.role === 'tenant' ? '/portal' : '/dashboard';
            return <Navigate to={redirectPath} />;
        }
    }

    // If children are provided, render them; otherwise render Outlet (for nested routes)
    return children || <Outlet />;
};

export default ProtectedRoute;


